import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Calendar as Cal } from "lucide-react";

const isSameDay = (a, b) => a.slice(0, 10) === b.slice(0, 10);
const isThisWeek = (dateStr) => {
  const d = new Date(dateStr);
  const now = new Date();
  const diff = (d - now) / (1000 * 60 * 60 * 24);
  return diff >= 0 && diff <= 7;
};

export default function FPAgenda() {
  const [items, setItems] = useState([]);
  const [view, setView] = useState("today"); // today | week | month
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/fp/agenda").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  const today = new Date().toISOString().slice(0, 10);
  const filtered = items.filter((r) => {
    const d = r.desired_date || (r.scheduled_at || "").slice(0, 10);
    if (!d) return false;
    if (view === "today") return d === today;
    if (view === "week") return isThisWeek(d);
    return true; // month = all upcoming
  }).sort((a, b) => (a.desired_date || "").localeCompare(b.desired_date || ""));

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8" data-testid="fp-agenda">
      <h1 className="font-display text-2xl sm:text-3xl font-bold text-[#0B2B62] mb-6">Agenda</h1>

      <div className="flex gap-2 mb-6">
        {[
          { v: "today", l: "Hoje" }, { v: "week", l: "Semana" }, { v: "month", l: "Todos" },
        ].map((o) => (
          <button key={o.v} onClick={() => setView(o.v)}
            data-testid={`fp-agenda-view-${o.v}`}
            className={`px-4 py-2 rounded-lg text-sm font-medium ${
              view === o.v ? "bg-[#0B2B62] text-white" : "bg-white border border-slate-300 text-slate-600"
            }`}>{o.l}</button>
        ))}
      </div>

      {loading ? <div className="text-slate-500">Carregando…</div>
        : filtered.length === 0 ? (
          <div className="bg-white border-2 border-dashed border-slate-300 rounded-xl p-10 text-center">
            <Cal className="w-10 h-10 text-slate-400 mx-auto mb-3" />
            <div className="text-slate-700">Sem compromissos {view === "today" ? "para hoje" : view === "week" ? "esta semana" : "futuros"}.</div>
          </div>
        ) : (
          <div className="bg-white border border-slate-200 rounded-xl divide-y">
            {filtered.map((r) => (
              <Link key={r.id} to={`/filho-presente/solicitacoes/${r.id}`}
                className="flex items-center gap-4 px-4 py-3 hover:bg-slate-50">
                <div className="w-14 text-center">
                  <div className="text-lg font-bold text-[#0B2B62]">{(r.desired_date || "").slice(8, 10)}</div>
                  <div className="text-[10px] uppercase text-slate-500">{new Date(r.desired_date).toLocaleDateString("pt-BR", { month: "short" })}</div>
                </div>
                <div className="flex-1 min-w-0 border-l pl-4">
                  <div className="text-sm font-medium truncate">
                    {r.specialty || r.exam_type || r.type}
                  </div>
                  <div className="text-xs text-slate-500 truncate">
                    {r.beneficiary_name} · {r.desired_time || "sem horário"}
                  </div>
                </div>
                <span className="text-xs px-2 py-0.5 rounded-full bg-slate-100 text-slate-600 shrink-0">
                  {r.status?.replace("_", " ")}
                </span>
              </Link>
            ))}
          </div>
        )}
    </div>
  );
}
